import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@/icons';

interface AcceptCaseSuccessModalProps {
    isOpen: boolean;
    caseId: string | null;
    onClose: () => void;
    onGoToCase: () => void;
}

export const AcceptCaseSuccessModal: React.FC<AcceptCaseSuccessModalProps> = ({
    isOpen,
    caseId,
    onClose,
    onGoToCase,
}) => {
    const theme = useTheme();

    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
        }}>
            <div style={{
                backgroundColor: (theme.colors.background as any)?.primary || '#ffffff',
                borderRadius: '8px',
                padding: '24px',
                maxWidth: '500px',
                width: '90%',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px',
                }}>
                    <h2 style={{
                        margin: 0,
                        fontSize: theme.typography?.fontSize?.xl || '24px',
                        fontWeight: 'bold',
                        color: theme.colors.primary || '#6B46C1',
                        textTransform: 'uppercase',
                    }}>
                        Accept Case
                    </h2>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '20px',
                            color: theme.colors.text?.secondary || '#6b7280',
                            padding: '4px 8px',
                        }}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>

                <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '12px',
                    marginBottom: '20px',
                }}>
                    <div style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        backgroundColor: '#000000',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        marginTop: '2px',
                    }}>
                        <FontAwesomeIcon
                            icon={faCheck}
                            style={{
                                color: '#ffffff',
                                fontSize: '14px',
                            }}
                        />
                    </div>
                    <p style={{
                        margin: 0,
                        fontSize: theme.typography?.fontSize?.sm || '14px',
                        color: theme.colors.text?.primary || '#000000',
                        lineHeight: '1.5',
                    }}>
                        Success! You have accepted this case and it will now appear on your My Team's Cases tab. We can also take you to view / edit it now.
                    </p>
                </div>

                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '12px',
                }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: '8px 16px',
                            border: `1px solid ${theme.colors.border?.default || '#e5e7eb'}`,
                            borderRadius: '4px',
                            backgroundColor: (theme.colors.background as any)?.primary || '#ffffff',
                            color: theme.colors.text?.primary || '#000000',
                            cursor: 'pointer',
                            fontSize: theme.typography?.fontSize?.sm || '14px',
                        }}
                    >
                        Close this window
                    </button>
                    <button
                        onClick={onGoToCase}
                        disabled={!caseId}
                        style={{
                            padding: '8px 16px',
                            border: 'none',
                            borderRadius: '4px',
                            backgroundColor: !caseId
                                ? (theme.colors.primary || '#6B46C1') + '80'
                                : theme.colors.primary || '#6B46C1',
                            color: '#ffffff',
                            cursor: !caseId ? 'not-allowed' : 'pointer',
                            fontSize: theme.typography?.fontSize?.sm || '14px',
                            fontWeight: '500',
                        }}
                    >
                        Go to the Case
                    </button>
                </div>
            </div>
        </div>
    );
};
